import { Component, Input } from '@angular/core';

/**
 * Stub component that replaces `<nvd3>` from the unmaintained `ng2-nvd3` package.
 * Renders a placeholder container so existing dashboards keep their layout while
 * the chart implementation is migrated to a supported charting library.
 */
@Component({
    standalone: false,
    selector: 'nvd3',
    template: '<div class="nvd3-stub"></div>'
})
export class Nvd3StubComponent {
    @Input() options: any;
    @Input() data: any;
}
